/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Faq_2_AInputs */

const en_serve_faq_2_a = /** @type {(inputs: Serve_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing extra from Bystep: steps built on your computer do not use your step credits. Your Claude or ChatGPT subscription is used as usual.`)
};

const id_serve_faq_2_a = /** @type {(inputs: Serve_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari Bystep tidak ada tambahan: langkah yang dibangun di komputermu tidak memakai jatah langkah. Langganan Claude atau ChatGPT-mu terpakai seperti biasa.`)
};

/**
* | output |
* | --- |
* | "Nothing extra from Bystep: steps built on your computer do not use your step credits. Your Claude or ChatGPT subscription is used as usual." |
*
* @param {Serve_Faq_2_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_faq_2_a = /** @type {((inputs?: Serve_Faq_2_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Faq_2_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_faq_2_a(inputs)
	return en_serve_faq_2_a(inputs)
});